import { refreshAuthenticated } from '../services/auth-api';
import {
  setTokens,
  getRefreshToken,
  removeStore,
} from '../services/localStorage-api';

const onRefreshToken = async () => {
  const refreshToken = getRefreshToken();

  try {
    const res = await refreshAuthenticated({ refresh: refreshToken });

    if (!res?.data?.access) {
      removeStore();
      return null;
    } else {
      setTokens(res.data.access, res.data.refresh || refreshToken);
      return res;
    }
  } catch (error) {
    removeStore();
    throw error;
  }
};

export default onRefreshToken;
